import { styled } from '@mui/material/styles';

import AtomGrid from '../../../components/atoms/AtomGrid';
import { styleConfigs } from '../../../components/resources/styleConfigs';

export const LogoContainerStyled = styled(AtomGrid)({
  display: 'flex',
  justifyContent: 'center',
  paddingBlockStart: styleConfigs.marginPadding.custom32,
  paddingBlockEnd: styleConfigs.marginPadding.custom5,
  paddingInline: styleConfigs.marginPadding.custom40,
});
